import firebase from 'firebase'
import db from '@/firebase/init'

export async function purgeArchivedUserCourses({ uid, cid }) {
  if (!uid) {
    throw new Error('Missing user uid for archived course purge.')
  }

  let currentCourseRef = db
    .collection('currentcourses')
    .where('user', '==', uid)
    .where('status', '==', 'archived')
  if (cid) currentCourseRef = currentCourseRef.where('cid', '==', cid)

  const archivedSnap = await currentCourseRef.get()
  const result = {
    archivedCount: archivedSnap.size,
    deletedCurrentCourses: 0,
    deletedCourseContent: 0,
    deletedStorage: 0,
    deletedMissions: 0,
    errors: [],
  }

  if (archivedSnap.empty) return result

  const storageRef = firebase.storage().ref()

  for (const doc of archivedSnap.docs) {
    const data = doc.data() || {}
    const courseID = data.courseID || null

    try {
      if (courseID) {
        const courseContentSnap = await db
          .collection('coursecontent')
          .where('courseID', '==', courseID)
          .get()
        for (const contentDoc of courseContentSnap.docs) {
          await contentDoc.ref.delete()
          result.deletedCourseContent += 1
        }
      }
    } catch (error) {
      result.errors.push({
        type: 'coursecontent',
        message: error?.message || 'Failed to delete coursecontent',
        courseID,
      })
    }

    if (data.storageRef) {
      try {
        await storageRef.child(data.storageRef).delete()
        result.deletedStorage += 1
      } catch (error) {
        result.errors.push({
          type: 'storageRef',
          message: error?.message || 'Failed to delete course storage',
          storageRef: data.storageRef,
          courseID,
        })
      }
    }

    if (data.missions) {
      try {
        await storageRef.child(data.missions).delete()
        result.deletedMissions += 1
      } catch (error) {
        result.errors.push({
          type: 'missions',
          message: error?.message || 'Failed to delete mission storage',
          missions: data.missions,
          courseID,
        })
      }
    }

    try {
      await doc.ref.delete()
      result.deletedCurrentCourses += 1
    } catch (error) {
      result.errors.push({
        type: 'currentcourses',
        message: error?.message || 'Failed to delete currentcourses doc',
        courseID,
      })
    }
  }

  return result
}
